import { Component, Prop, Element, h } from "@stencil/core";
import { StringUtils } from "../../core/utils/StringUtils";

@Component({
    tag: "snt-feature-left",
    styleUrl: "./feature-left-component.scss",
    shadow: false
})
export class FeatureLeftComponent {

    @Element() hostElement: HTMLElement;
    @Prop({ reflect: true }) imgSrc!: string;
    @Prop({ reflect: true }) imgSrcSet: string = StringUtils.empty();
    @Prop({ reflect: true }) titleText!: string;
    @Prop({ reflect: true }) timeToRead!: string;
    @Prop({ reflect: true }) tagText!: string;
    @Prop({ reflect: true }) blogLink!: string;
    @Prop({ reflect: true }) imgAltText: string = "";
    @Prop({ reflect: true }) openInNewWindow: boolean = false;

    public static readonly TAG_NAME = "snt-feature-left";


    render() {
        const skipRender = this.hostElement.getAttribute('skipRender');
        return skipRender ? null : [
            <a href={this.blogLink} target={this.openInNewWindow ? "_blank" : "_self"}>
                <div class="article-container">
                    <div class='article-img'>
                        <snt-image data-src={this.imgSrc} img-alt={this.imgAltText}></snt-image>
                    </div>
                    <div class='article-tag'>
                        <span>{this.tagText}</span>
                    </div>
                    <div class='article-content'>
                        <div class="article-title">
                            <div class="h4">{this.titleText}</div>
                        </div>
                    </div>
                    <span class="article-min-read">{this.timeToRead}</span>
                </div>
            </a>
        ];
    }
}
